import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import HttpXmlConnectorForm from '../forms/http-xml-connector-form';
import { httpXmlConnectorValidationSchema } from '../schema/httpXmlConnector.js';

export default function HttpXmlConnectorNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'HTTP XML Connector Node Details',
        altText: 'HTTP XML Connector Node',
        defaultLabel: 'HTTP XML Connector Node',
      }}
    >
      <CommonNode
        FormComponent={HttpXmlConnectorForm}
        schemaResolver={httpXmlConnectorValidationSchema}
      />
    </NodeProvider>
  );
}
